<template>
    <div class="chart-container">
        <div class="metric-label label">
            {{ model.label }}
        </div>
        <div class="headers">
            <div class="deprivation-label">
                Most Well Off
            </div>
            <div class="lga">
                {{ model.valueLabel }}
            </div>
            <div class="compare">
                {{ model.comparisonLabel }}
            </div>
        </div>
        <div
            v-for="(childModel, i) in model.submodels"
            :key="i"
            class="value-row"
            :id="childModel.id"
        >
            <div class="label">
                {{ childModel.label }}
            </div>
            <dynamic-resize-container
                class="deprivation-metric-chart deprivation-bar"
            >
                <template
                    #default="{width}"
                >
                    <bullet-chart
                        class="deprivation-bar"
                        :width="width"
                        :height="10"
                        :value="childModel.value"
                        :compare-value="childModel.comparisonValue"
                    >
                        <template
                            #tooltip-content="{ type }"
                        >
                            <div>
                                <div class="tooltip-label">
                                    {{ childModel.valueLabel }}
                                </div>
                                <div :class="`tooltip-value ${type === 'value' ? 'highlight' : ''}`">
                                    {{ childModel.formatWithUnits(childModel.value) }}
                                </div>
                                <div class="tooltip-compare-value">
                                    <span :class="`${type === 'compare' ? 'highlight' : ''}`">{{ childModel.formatWithUnits(childModel.comparisonValue) }}</span> in {{ childModel.comparisonLabel }}
                                </div>
                            </div>
                        </template>
                    </bullet-chart>
                </template>
            </dynamic-resize-container>
            <div class="lga value">
                {{ childModel.formatWithUnits(childModel.value) }}
            </div>
            <div class="compare value">
                {{ childModel.formatWithUnits(childModel.comparisonValue) }}
            </div>
        </div>

        <div class="footer">
            <div class="deprivation-label">
                Most Deprived
            </div>
        </div>

        <info-tooltip
            :definition="model.definition"
            :link-to-health="model.linkToHealth"
            :data-source="model.dataSource"
        />
    </div>
</template>

<script>
import DynamicResizeContainer from '@/components/DynamicResizeContainer.vue';
import BulletChart from '@/components/BulletChart.vue';
import InfoTooltip from '@/components/InfoTooltip.vue';

export default {
    components: {
        DynamicResizeContainer, BulletChart, InfoTooltip
    },
    props: {
        model: {
            type: Object,
            required: true
        }
    }
};
</script>

<style src="./common.container.css" scoped></style>
<style lang="postcss" scoped>
.chart-container {
    @apply pr-6 mt-2 text-neutral-label;
}

.headers {
    @apply flex flex-row mb-2 justify-between items-end;
}

.header-placeholder {
    @apply flex-grow-0;
    width: 150px;
}

.headers div {
    @apply text-2xs;
}

.footer div.deprivation-label, .headers div.deprivation-label {
    @apply w-3/5 text-2xs text-neutral-label flex-grow-0;
}

.value-row {
    @apply flex flex-row items-center justify-between mb-1;
}

.value-row .label {
    @apply text-2xs w-2;
}

.deprivation-bar {
    @apply text-sm flex-grow-0;
    width: calc(60% - 8pt);
}

.label.metric-label {
    @apply mb-4;
}

.lga {
    @apply w-1/5 text-right;
}

.compare {
    @apply w-1/5 text-right text-neutral-text;
}

.value {
    @apply text-xs font-normal;
}
.pdf .resize-container.deprivation-metric-chart {
    min-width: 220px;
    max-width: 220px;
}

</style>
<style lang="postcss">
.deprivation-metric-chart.deprivation-bar line.compare-value {
    stroke-width: 2px;
}
</style>
